import React from "react";
import Grid from "../../../Grid/Grid";
import Blob from "../../../../assets/blobs/blob-3.svg";
import "./home-steps.scss";

const HomeSteps = ({ steps }) => {
  return (
    <section className="home-steps">
      <Grid className="home-steps__grid">
        <div className="home-steps__container">
          <h2 className="home-steps__heading">How Does it Work?</h2>
          <div className="home-steps__ol-wrapper">
            <ol className="home-steps__ol">
              {steps.map((step, index) => (
                <li className="home-steps__li" key={index}>
                  <div className="home-steps__li__step">{step}</div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </Grid>
      <Blob className="home-steps__blob" />
    </section>
  );
};

export default HomeSteps;
